/**
 * Environment check utility
 * Determines if AI features should be enabled based on current environment
 */

/**
 * Check if current environment is production
 * @returns {boolean} true if in production environment
 */
export const isProductionEnvironment = () => {
  const mode = process.env.VUE_APP_MODE;
  
  // Check if explicitly set to production mode
  return mode === 'production';
};

/**
 * Check if AI features should be enabled
 * @returns {boolean} true if AI features should be enabled
 */
export const isAIFeaturesEnabled = () => {
  return !isProductionEnvironment();
};

/**
 * Get current environment name
 * @returns {string} current environment name
 */
export const getCurrentEnvironment = () => {
  return process.env.VUE_APP_MODE || 'development';
};